import React from 'react';
import { 
  FaMousePointer,
  FaHandPaper,
  FaPencilAlt, 
  FaRuler, 
  FaEraser, 
  FaMap, 
  FaUsers, 
  FaSyncAlt, 
  FaCog 
} from 'react-icons/fa';
import './TableSidebar.css';

const TableSidebar = ({ 
  onToggleMapSelector, 
  onToggleEnemySelector,
  onToggleSettings,
  isMapVisible, 
  isEnemyVisible,
  interactionMode,
  onModeChange,
  onClearDrawings,
  onResetMap
}) => {
  return (
    <div className="table-sidebar">
      <div className="sidebar-top-buttons">
        <button 
          className={`sidebar-button ${interactionMode === 'click' ? 'active' : ''}`}
          onClick={() => onModeChange('click')}
          title="Click Mode"
        >
          <FaMousePointer />
        </button>

        <button 
          className={`sidebar-button ${interactionMode === 'pan' ? 'active' : ''}`}
          onClick={() => onModeChange('pan')}
          title="Pan Mode"
        >
          <FaHandPaper />
        </button>

        <button 
          className={`sidebar-button ${interactionMode === 'draw' ? 'active' : ''}`}
          onClick={() => onModeChange('draw')}
          title="Draw Mode"
        >
          <FaPencilAlt />
        </button>
        
        <button 
          className="sidebar-button"
          onClick={onClearDrawings}
          title="Clear Drawings"
        >
          <FaEraser />
        </button>
        
        <button 
          className={`sidebar-button ${interactionMode === 'ruler' ? 'active' : ''}`}
          onClick={() => onModeChange('ruler')}
          title="Measure Distance"
        >
          <FaRuler />
        </button>

        <button 
          className={`sidebar-button ${isMapVisible ? 'active' : ''}`}
          onClick={onToggleMapSelector}
          title="Toggle Map Selector"
        >
          <FaMap />
        </button>
        
        <button 
          className={`sidebar-button ${isEnemyVisible ? 'active' : ''}`}
          onClick={onToggleEnemySelector}
          title="Toggle Enemy Selector"
        >
          <FaUsers />
        </button>
      </div>

      <div className="sidebar-bottom-buttons">
        <button 
          className="sidebar-button"
          onClick={onResetMap}
          title="Reset Map"
        >
          <FaSyncAlt />
        </button>
        
        <button 
          className="sidebar-button"
          onClick={onToggleSettings}
          title="Settings"
        >
          <FaCog />
        </button>
      </div>
    </div>
  );
};

export default TableSidebar;